import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { ProfileOverviewComponent } from "./profile-overview.component";
import { RecoveryFlow } from "../shared/login.enum";
import { ChangeUsernameComponent } from "../change-username/change-username.component";
import { ProfileNavService } from '../shared/profile-nav.service';

class ProfileOverviewFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: any;
    correlationId: string;
    flow: string;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    profileOverviewComponentRef: ComponentRef<ProfileOverviewComponent>;
   navSubscription: any;
 
    constructor(formId: string, payload: object) {
        console.log('Inside ProfileOverviewFormSession constructor');
        this.formId = formId;
        this.payload = payload;
        if(this.payload?.actions?.length > 0) {
            this.flow = this.payload?.actions[0]?.flow
        }
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('ProfileOverviewFormSession session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;

  //       const navService = (window as any).profileNavService;

  //         if (navService) {


  //   this.navSubscription =

  //     navService.navigation$

  //       .subscribe((flow: string) => {


  //         if (this.submitBlock) {


  //           this.submitBlock({

  //             flow

  //           });


  //         }


  //       });


  // }
      }

      endSession(): void {
          this.navSubscription?.unsubscribe();
        console.log('ProfileOverviewFormSession session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('ProfileOverviewFormSession session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        
        const factory: ComponentFactory<ProfileOverviewComponent> =
        self.resolver.resolveComponentFactory(ProfileOverviewComponent);

        self.profileOverviewComponentRef = self.viewContainerRef.createComponent(factory);
        self.profileOverviewComponentRef.instance.userProfileDetails = this.payload;
        self.profileOverviewComponentRef.instance.selectedForm = this.flow;
        
        self.profileOverviewComponentRef.instance.onSubmitFlow = this.onSubmitForm;

        const dataArray = [this.payload];
        this.clientContext['cookieService'].set('userProfileDetails', JSON.stringify(dataArray), undefined, undefined, null, true, 'None');

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            // try {
            //   resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));
            //   console.log('ProfileOverviewFormSession createFormInputSubmissionRequest SUCCESS payload: ', payload);
            //   self.submitBlock = null;
            // } catch (e) {
            //   console.log('ProfileOverviewFormSession createFormInputSubmissionRequest ERROR payload: ', payload);
            //   console.error(e);
            // }
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {
          console.error(e);
        }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('ProfileOverviewFormSession onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('ProfileOverviewFormSession onError for ' + this.formId + ' payload:', payload);
      }

    onSubmitForm = (flow: object) => {
    // const inputResponse = com.ts.mobile.sdk.PasswordInput.create(flow);
    //const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(flow);
    this.submitBlock(flow);
  }

  private onSubmitNewUseruserName(payload: object) {
    const data = payload;
    this.submitBlock(data);
  }
}

export default ProfileOverviewFormSession;
